import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-074054dc")

_pushScopeId("data-v-074054dc")
const _hoisted_1 = {
  class: "toc_ui__checkItem_main",
  id: "checkItemMain"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkItem = _resolveComponent("checkItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.isRenderVersion241226)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item, index) => {
            return _withDirectives((_openBlock(), _createBlock("div", {
              key: item.code
            }, [
              _createVNode(_component_checkItem, {
                renderData: item,
                dataIndex: index
              }, null, 8, ["renderData", "dataIndex"])
            ], 512)), [
              [_vShow, !_ctx.state.tocOnlyShowFlaw || (item.defectCount>0 && _ctx.state.tocOnlyShowFlaw)]
            ])
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item, index) => {
            return _withDirectives((_openBlock(), _createBlock("div", {
              key:  item.itemCode
            }, [
              _createVNode(_component_checkItem, {
                renderData: item,
                dataIndex: index
              }, null, 8, ["renderData", "dataIndex"])
            ], 512)), [
              [_vShow, !_ctx.state.tocOnlyShowFlaw || (item.defectItemCount>0 && _ctx.state.tocOnlyShowFlaw)]
            ])
          }), 128))
        ]))
  ]))
})